import moment from 'moment'
import clients from 'redux/clients'
import { availableVendors } from '../../../Participant/MyOrders/ProductOrderDetail/ProductSide'

const {
  cloudloyalty: { client }
} = clients

const {
  cloudloyalty: { client: clientCloudLoyalty }
} = clients

const defaultStatusTracking = {
  statuses: [
    {
      status: '1',
      name: 'Produto solicitado',
      when: null
    },
    {
      status: '2',
      name: 'Produto confirmado no parceiro',
      when: null
    },
    {
      status: '3',
      name: 'Produto enviado para a transportadora',
      when: null
    },
    {
      status: '4',
      name: 'Produto em rota de entrega',
      when: null
    },
    {
      status: '5',
      name: 'Produto entregue',
      when: null
    }
  ]
}

export const loadMyOrdersTracking = () => {
  return (dispatch, getState) => {
    dispatch({ type: 'FETCH_ORDER_TRACKING' })

    const handleSuccess = payload => {
      dispatch({ type: 'FETCH_ORDER_TRACKING_SUCCESS', payload })
    }

    const handleError = err => {
      dispatch({ type: 'FETCH_ORDER_TRACKING_FAIL', error: { data: err } })
    }

    const dateFrom = moment()
      .subtract(11, 'd')
      .format('DD/MM/YYYY')

    let formattedInitialDate = dateFrom
    let formattedEndDate = moment.utc().format('DD/MM/YYYY')

    client
      .get(
        `/v1/purchases/me/orders?orderId=&startDate=${formattedInitialDate}&endDate=${formattedEndDate}&offset=0&limit=0`
      )
      .then(handleSuccess)
      .catch(handleError)
  }
}

export const loadProductsTracking = (cache, pageIndex, pageSize) => {
  return (dispatch, getState) => {
    dispatch({ type: 'FETCH_PRODUCTS_TRACKING' })

    const handleSuccess = payload => {
      dispatch({ type: 'FETCH_PRODUCTS_TRACKING_SUCCESS', payload, pageIndex })
    }

    const handleError = err => {
      dispatch({ type: 'FETCH_PRODUCTS_TRACKING_FAIL', error: { data: err } })
    }

    let formattedInitialDate = moment()
      .subtract(11, 'd')
      .format('DD/MM/YYYY')
    let formattedEndDate = moment.utc().format('DD/MM/YYYY')

    let data = {
      statusGroupFilters: [
        { descriptionStatusGroup: 'Confirmado' },
        { descriptionStatusGroup: 'Enviado' },
        { descriptionStatusGroup: 'Pendente' },
        {
          descriptionStatusGroup: 'Entregue',
          innitialDate: formattedInitialDate,
          endDate: formattedEndDate
        }
      ],
      pageIndex,
      pageSize
    }

    clientCloudLoyalty
      .post(`/v1/purchases/me/search?cache=${cache}`, data)
      .then(handleSuccess)
      .catch(handleError)
  }
}

export const getOrderListDetails = (
  parentOrderId,
  orderId,
  productId,
  fromOrderDetail
) => {
  return {
    type: 'GET_ORDERLIST',
    parentOrderId: parentOrderId,
    productId: productId,
    orderId: orderId,
    fromOrderDetail: fromOrderDetail,
    payload: {
      client: 'tracking',
      request: {
        method: 'get',
        url: `/timelines/${orderId}`
      }
    }
  }
}

export const getTrackingStatus = order => {
  let sku = order.productCode
  if (sku) {
    let splitSku = sku.split('-')
    if (splitSku.length > 0) sku = splitSku[0]
  }

  if (!availableVendors.includes(order.vendorId)) {
    if (order.vendorType === 'e-Commerce') {
      let status = { ...defaultStatusTracking }
      status.statuses[0].when = order.insertDate
      return insertTrackingStatus(order.orderId, status, order.id, sku)
    } else {
      return insertLastEventTrackingStatus(
        order.orderId,
        order.orderStatusId,
        order.id,
        sku
      )
    }
  }

  return {
    type: 'GET_TRACKING_STATUS',
    orderId: order.orderId,
    sku,
    id: order.id,
    payload: {
      client: 'tracking',
      request: {
        method: 'get',
        url: `/timelines/${order.orderId}/items/${sku}`
      }
    }
  }
}

export const insertNetshoesLastEvent = (orderId, status) => {
  return {
    type: 'INSERT_NETSHOES_LAST_EVENT',
    orderId: orderId,
    status: status
  }
}

export const insertLastEventTrackingStatus = (
  orderId,
  status,
  orderItemId,
  sku
) => {
  return {
    type: 'INSERT_NETSHOES_EVENT_TRACKING_STATUS',
    orderId,
    status,
    orderItemId,
    sku
  }
}

export const insertTrackingStatus = (orderId, status, orderItemId, sku) => {
  return {
    type: 'INSERT_TRACKING_STATUS',
    orderId,
    status,
    orderItemId,
    sku
  }
}
export default client => ({
  loadMyOrdersTracking: loadMyOrdersTracking(),
  getOrderListDetails,
  loadProductsTracking,
  getTrackingStatus
})



// WEBPACK FOOTER //
// ./src/App/Header/Tracking/actions.js